import React, { Component } from "react";
import { MDBListGroup, MDBListGroupItem } from "mdbreact";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import { connect } from "react-redux";
import { Facebook } from "react-content-loader";
import cx from "classnames";
import {
  selectFeatureById,
  selectFeature
} from "~/store/features/featuresActions";
import styles from "./style.module.scss";
import {
  selectHospital,
  changeBookingFlow,
  getBookingTree
} from "~/store/totalData/actions";
import { getHistoryPayment } from "~/store/fee/feeActions";
import AppId from "~/utils/partner";
import Modal from "~/components/common/molecules/Modal";
import { OK, CLOSE } from "~/utils/constants";
import searchInfo from "~/assets/img/desktop/HompageClinic/searchInfo.svg";
class ListServiceNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleModalConfirm: false,
      selectItem: "",
      message: "",
      isShowMessage: false
    };
  }

  handleOpenToggleModalConfirm = item => {
    this.setState({ toggleModalConfirm: true, selectItem: item });
  };

  handleCloseToggleModalConfirm = () => {
    this.setState({ toggleModalConfirm: false, selectItem: "" });
  };

  handleChooseFeature = item => {
    const { message } = item;

    if (message) {
      this.setState({
        isShowMessage: true,
        message
      });
    } else {
      this.props.selectFeature(item.type);
      this.props.selectFeatureById(item.id);
    }
  };

  toggleModalChoosePatient = () => {
    this.setState({
      isShowMessage: !this.state.isShowMessage
    });
  };

  renderIsAuthenticated = item => {
    const imageErrorSrc = "/umc1/assets/icon/serviceDefault.svg";
    const urlImage = item.image || imageErrorSrc;

    if (AppId === "medpro") {
      return (
        <Link
          to="/chon-benh-vien"
          onClick={() => {
            this.props.selectFeatureById(item.id);
          }}
        >
          <LazyLoad height={65}>
            <img
              src={urlImage}
              onError={e => {
                e.target.src = imageErrorSrc;
              }}
              className={cx(styles.itemImg)}
              alt={item.name}
            />
          </LazyLoad>
          <h3>{item.name}</h3>
        </Link>
      );
    } else {
      return (
        <>
          <LazyLoad height={65}>
            <img
              src={urlImage}
              onError={e => {
                e.target.src = imageErrorSrc;
              }}
              className={cx(styles.itemImg)}
              alt={item.name}
            />
          </LazyLoad>
          <h3>{item.name}</h3>
        </>
      );
    }
  };

  renderServicesList = () => {
    const { list = [] } = this.props;
    const sort = list.sort((a, b) => Number(a.priority) - Number(b.priority));
    const serviceListNode = sort.map((item, i) => {
      return item.status ? (
        <MDBListGroupItem
          key={i}
          onClick={() => {
            item.type === "payment.fee"
              ? this.handleOpenToggleModalConfirm(item)
              : this.handleChooseFeature(item);
          }}
        >
          {this.renderIsAuthenticated(item)}
        </MDBListGroupItem>
      ) : null;
    });
    return serviceListNode;
  };

  renderModalChooseHospital = () => {
    return (
      <Modal
        iconTitle={<i className="fal fa-bell" />}
        modal={this.state.isShowMessage}
        toggle={this.toggleModalChoosePatient}
        title="Thông báo"
        children={this.state.message}
        centered
        className="centered"
        footer
        footerConfirm
        cancelText=""
        okText="Gọi ngay"
        onOk={() => {
          window.open("tel:19002115", "_self");
        }}
      />
    );
  };

  renderModalFee = () => {
    return (
      <Modal
        modal={this.state.toggleModalConfirm}
        toggle={() => this.handleCloseToggleModalConfirm()}
        children="Đây là tính năng có tính phí. Bạn có muốn tiếp tục?"
        centered
        className="centered"
        cancelText={CLOSE}
        okText={OK}
        onCancel={this.handleCloseToggleModalConfirm}
        onOk={() => this.handleChooseFeature(this.state.selectItem)}
        footer
        footerConfirm
      />
    );
  };

  render() {
    const { loading } = this.props;
    return (
      <React.Fragment>
        <MDBListGroup
          className={cx(
            styles.list_group,
            styles.list_service_mobile,
            styles["list_group_" + AppId]
          )}
        >
          {loading ? (
            <Facebook />
          ) : (
            <>
              {this.renderServicesList()}
              <li
                data-test="list-group-item"
                className="list-group-item list-group-item-undefined"
              >
                <a href="/umc1/user">
                  <div className="lazyload-wrapper ">
                    <img
                      src={searchInfo}
                      className="style_itemImg__2MLAS"
                      alt="Search Info"
                    />
                  </div>
                  <h3>Tra cứu thông tin</h3>
                </a>
              </li>
              <li
                data-test="list-group-item"
                className={cx(styles.item200, "list-group-item")}
              >
                <a href="https://medpro.vn/co-so-y-te">
                  <h3>Đặt khám nhanh 200+ CSYT khác</h3>
                </a>
                <div className={cx(styles.new)}>NEW</div>
              </li>
            </>
          )}
        </MDBListGroup>

        {this.renderModalFee()}
        {this.renderModalChooseHospital()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated },
    features: {
      allFeatures: { loading, list }
    },
    hospital: {
      hospitalList: { data: allListHospital }
    },
    totalData: { partnerId }
  } = state;
  return {
    partnerId,
    list,
    loading,
    IsAuthenticated,
    allListHospital
  };
};
export default connect(mapStateToProps, {
  getHistoryPayment,
  selectFeatureById,
  selectHospital,
  changeBookingFlow,
  getBookingTree,
  selectFeature
})(ListServiceNew);
